import { fetchError, fetchStart, fetchSuccess } from './Common';
import { client } from 'services/http';
import {
  ADD_RELATION,
  CLEAR_CURRENT_RLATION,
  DELETE_RELATION,
  EDIT_RELATION,
  GET_CURRENT_RELATION,
  GET_RELATIONS,
} from '@jumbo/constants/ActionTypes';

export const getRelations = id => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v1/integration_resources/`, {
        params: {
          by_movie_id: id,
        },
      })
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_RELATIONS, payload: data.data });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response.data.error[0]));
      });
  };
};

export const createRelation = ({ relation, movieId }, history) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .post(`/share/v1/integration_resources/`, relation)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: ADD_RELATION, payload: data.data });
          history.push(`/relation-managment/?movie=${movieId}`);
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response.data.error[0]));
      });
  };
};

export const updateRelation = ({ relation, id, movieId }, history) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .put(`/share/v1/integration_resources/${id}`, relation)
      .then(data => {
        if (data.status === 200 || data.status === 201) {
          dispatch(fetchSuccess());
          dispatch({ type: EDIT_RELATION, payload: data.data });
          history.push(`/relation-managment/?movie=${movieId}`);
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response.data.error[0]));
      });
  };
};

export const getCurrentRelation = (id, movieId, history) => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .get(`/share/v1/integration_resources/${id}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: GET_CURRENT_RELATION, payload: data.data });
          if (history) {
            history.push(`/create-relation/?relation=${id}&movie=${movieId}`);
          }
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response.data.error[0]));
      });
  };
};

export const deleteRelation = id => {
  return dispatch => {
    dispatch(fetchStart());
    client
      .delete(`/share/v1/integration_resources/${id}`)
      .then(data => {
        if (data.status === 200) {
          dispatch(fetchSuccess());
          dispatch({ type: DELETE_RELATION, payload: id });
        } else {
          dispatch(fetchError('Something went wrong'));
        }
      })
      .catch(error => {
        dispatch(fetchError(error.response.data.error[0]));
      });
  };
};

export const clearCurrentRelation = () => {
  return dispatch => {
    dispatch({
      type: CLEAR_CURRENT_RLATION,
    });
  };
};
